import $ from 'jquery'
import './main.scss'

$(document).on('change', '.quiz__answers', (e) =>
  $('.quiz__check-answer').prop(
    'disabled',
    $('.quiz__answers input:checked').length === 0
  )
)

$(() =>
  $('.quiz__check-answer').prop(
    'disabled',
    $('.quiz__answers input:checked').length === 0
  )
)

$(document).on('submit', '.answer_question_form', function (e) {
  $(this).find('.quiz__check-answer').addClass('btn--loading')
  return $(this).find('.quiz__check-answer').prop('disabled', true)
})
